// extracted by mini-css-extract-plugin
export default {"listItemIconWidth":"21","mappingColumnPaddingLeft":"15","datasetColumnPaddingLeft":"15"};